import { ElementRef, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface MenuToggleEvent {
  state: boolean;
  element: ElementRef;
}

@Injectable({
  providedIn: 'root'
})
export class MenuToggleService {

  subject = new Subject<MenuToggleEvent>();
  
  constructor() { }

  public toggle(): Observable<MenuToggleEvent> {
    return this.subject;
  }

}
